exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.saved-modal[data-v-efd42360] {\n  background: rgba(255, 255, 255, 0.95);\n}\n", ""]);

// exports
